<script setup>
import { AUTHOR_VARIANTS } from '@/utils/components-configurations/checkin-field'
import { SKELETON_SIZES } from '@/utils/components-configurations/skeleton-item'
import { OBJECTIVE_TYPES } from '@/utils/objective-types'

import CheckinPreviewLoader from '@/components/objectives/element-check-in/CheckinPreviewLoader'
import SkeletonItem from '@/components/ui/SkeletonLoaders/SkeletonItem'

defineOptions({
  name: 'CheckinsFeedLoader'
})

defineProps({
  showTitle: {
    type: Boolean
  }
})
</script>

<template>
  <div class="cfl-Loader">
    <div v-if="showTitle" class="cfl-Loader_Title">
      <SkeletonItem height="18px" width="220px" />
    </div>

    <div
      :class="{
        'cfl-Loader_Checkin-no-title': !showTitle
      }"
      class="cfl-Loader_Checkin"
    >
      <CheckinPreviewLoader
        :author-variant="AUTHOR_VARIANTS.COMPACT"
        :element-type-id="OBJECTIVE_TYPES.KR"
        show-element
      />

      <div class="cfl-Loader_Actions">
        <SkeletonItem :size="SKELETON_SIZES.SM" width="64px" />
        <SkeletonItem :size="SKELETON_SIZES.SM" width="44px" />
        <SkeletonItem :size="SKELETON_SIZES.SM" width="44px" />
        <SkeletonItem :size="SKELETON_SIZES.SM" width="70px" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '~@/assets/styles/checkins-feed';

.cfl-Loader {
  --checkin-layout-body-gap: 4px;
  --checkin-layout-row-gap: 18px;
}

.cfl-Loader_Checkin {
  padding-bottom: #{$checkin-feed-item-py};
  @extend %feed-item-common-styles;

  &-no-title {
    margin-top: 20px;
  }
}

.cfl-Loader_Title {
  height: 28px;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.cfl-Loader_Actions {
  display: flex;
  gap: 8px;
  margin-top: 17px;
  margin-left: #{$checkin-feed-item-px};
}
</style>
